import $ from "jquery";
// import settings from "/public/settings.js";

// const ROOT_URL = "https://api.truframe.co.uk:1985/pricingapi/";
var ROOT_URL = "https://apistaging.truframe.co.uk:1986/pricingapi/";

// hack
if (window.location.hostname === "www.quote-builder.co.uk") {
    ROOT_URL = "https://api.truframe.co.uk:1985/pricingapi/";
}


/**
 * 
 * When the api is sending the same object multiple time, it will actually have the first iteration with an added property "$id", and any following iteration with nothing but a "$ref" property.
 * This is to reduce amount of data coming back from the server.
 * To handle that, we go through the entire response looking for $id and $ref to do a "search and replace" on any query response provided
 * 
 * @param {*} data `result` from the an api call
 * @param {*} globalReferences only used when self-called
 */
const checkGlobalReference = (data, globalReferences = {}) => {

    // if data is falsey, just return it as it will break some things for certain values (null, undefined, etc)
    if(!data){
        return data;
    }

    // if we can map it, it's an array, so go through every element and call itself with it
    if(data.map){
        return data.map(subData => checkGlobalReference(subData, globalReferences));
    }

    // if we have found the $ref, replace the data by returning the one we cached in global references
    if(data["$ref"]){
        return globalReferences[data["$ref"]];
    }

    // if we found $id, cache it inside the global references
    if(data["$id"]){
        globalReferences[data["$id"]] = data;

        // if it's got an $id, it's an object, meaning we need to check every property to make sure we don't ignore sub-objects
        for(let prop in data){
            data[prop] = checkGlobalReference(data[prop], globalReferences);
        }
    }

    return data;
};

export const ajax = (type, url, data, handleError = true) => {
    let params = {
        xhrFields: {
            withCredentials: false
        },
        cache: false,
        // headers: {
        //     'Cache-Control': 'no-cache'
        // },
        type: type,
        url: `${ROOT_URL}${url}`,
        data: data
    };

    console.debug("API", type, url);

    var query = $.ajax(params);

    if (handleError) {
        query = query.fail((xhrRequest, status, errorMessage) => {
            console.error("type, url, data", type, url, data);
            console.error("xhrRequest, status, errorMessage", xhrRequest, status, errorMessage);

            if (process.env.NODE_ENV === "production") {
                alert("Sorry, there was an error contacting the servers.");
            }
        });
    }
    return query.then(data => {
        if(typeof data === "object") {
            if (data.result === null) data.result = [];
            data.result = checkGlobalReference(data.result);
        }
        return data;
    });
};

export const fetchOptions = (apiKey, url) => ajax("GET", `options/${apiKey}/${url}`);
export const fetchEnquiry = (apiKey, url, handleError) =>
    ajax("GET", `enquiry/${apiKey}/${url}`, undefined, handleError);
export const postEnquiry = (apiKey, method, url, body) =>
    ajax(method, `enquiry/${apiKey}/${url}`, body);
export const fetchPreviewUrls = (url, body) => ajax("GET", `enquiry/${url}`, body);



// WEBPACK FOOTER //
// ./src/actions/api.js